module.exports = __webpack_public_path__ + "img/product-type-wrap-bg.aa272c43.png";